import Hero from "../components/Hero";
import About from "../components/About";
import Skills from "../components/Skills";
import Certifications from "../components/Certifications";
import Experience from "../components/Experience";
import Projects from "../components/Projects";
import Contact from "../components/Contact";
// import Feedback from "../components/Feedback";

function Home() {
  return (
    <>
      <Hero />
      <About />
      <Skills />
      <Certifications />
      <Experience />
      <Projects />
      <Contact />

    </>
  );
}

export default Home;